import { cn } from '@/lib/utils';

type Priority = 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';

interface PriorityIconProps {
  priority: Priority;
  size?: number;
  className?: string;
}

const PRIORITY_BARS: Record<Priority, { filled: number; colorClass: string }> = {
  LOW: { filled: 1, colorClass: 'text-neutral-400' },
  MEDIUM: { filled: 2, colorClass: 'text-amber-500' },
  HIGH: { filled: 3, colorClass: 'text-orange-500' },
  CRITICAL: { filled: 4, colorClass: 'text-red-500' },
};

export function PriorityIcon({ priority, size = 16, className }: PriorityIconProps) {
  const { filled, colorClass } = PRIORITY_BARS[priority];

  // 4 bars with increasing height, spaced evenly across a 16x16 viewBox
  const barWidth = 2.5;
  const gap = 1.2;
  const totalWidth = barWidth * 4 + gap * 3;
  const offsetX = (16 - totalWidth) / 2;
  const bars = [
    { x: offsetX, height: 4 },
    { x: offsetX + barWidth + gap, height: 7 },
    { x: offsetX + (barWidth + gap) * 2, height: 10 },
    { x: offsetX + (barWidth + gap) * 3, height: 13 },
  ];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      className={cn(colorClass, className)}
      aria-label={`Priority: ${priority.toLowerCase()}`}
    >
      {bars.map((bar, i) => (
        <rect
          key={i}
          x={bar.x}
          y={15 - bar.height}
          width={barWidth}
          height={bar.height}
          rx={0.75}
          opacity={i < filled ? 1 : 0.2}
        />
      ))}
    </svg>
  );
}
